import { Box, styled } from '../../base';

export const ModalWrapper = styled(Box)(({ theme }) => ({
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
    borderRadius: 16,
}));
